module.exports = __webpack_public_path__ + "assets/img/SpinTel-Social-Static-Ad-w540.5d38b286.png";